import {
    GET_AREAS,
    GET_AREAS_SUCCESS,
    GET_AREAS_FAIL,
    ADD_AREA,
    ADD_AREA_SUCCESS,
    ADD_AREA_FAIL,
    UPDATE_AREA,
    UPDATE_AREA_SUCCESS,
    UPDATE_AREA_FAIL,
    DELETE_AREA,
    DELETE_AREA_SUCCESS,
    DELETE_AREA_FAIL,
  } from "./actionTypes";
  
  // GET
  export const getAreas = () => ({ type: GET_AREAS });
  export const getAreasSuccess = (areas) => ({
    type: GET_AREAS_SUCCESS,
    payload: areas,
  });
  export const getAreasFail = (error) => ({
    type: GET_AREAS_FAIL,
    payload: error,
  });
  
  // ADD
  export const addArea = (data) => ({ type: ADD_AREA, payload: data });
  export const addAreaSuccess = (area) => ({
    type: ADD_AREA_SUCCESS,
    payload: area,
  });
  export const addAreaFail = (error) => ({
    type: ADD_AREA_FAIL,
    payload: error,
  });
  
  // UPDATE
  export const updateArea = (data) => ({ type: UPDATE_AREA, payload: data });
  export const updateAreaSuccess = (area) => ({
    type: UPDATE_AREA_SUCCESS,
    payload: area,
  });
  export const updateAreaFail = (error) => ({
    type: UPDATE_AREA_FAIL,
    payload: error,
  });
  
  // DELETE
  export const deleteArea = (id) => ({ type: DELETE_AREA, payload: id });
  export const deleteAreaSuccess = (id) => ({
    type: DELETE_AREA_SUCCESS,
    payload: id,
  });
  export const deleteAreaFail = (error) => ({
    type: DELETE_AREA_FAIL,
    payload: error,
  });
  